/**
 * Attribute directive for uib-dropdown elements that closes the dropdown when
 * focus moves outside of it. Place on the same element as uib-dropdown.
 *
 * uib-dropdown's keyboard-nav only handles arrow keys and Escape — it does not
 * close the menu when the user Tabs past the last item. This directive fills
 * that gap by listening for the bubbling focusout event and, after yielding to
 * the browser so document.activeElement is updated, closing the dropdown if
 * focus has left the container.
 */
/* @ngInject */
export default function NvCloseDropdownOnBlur($timeout) {
  return {
    restrict: 'A',
    require: 'uibDropdown',
    link(scope, element, _attrs, dropdownCtrl) {
      let pendingTimeout = null;

      element.on('focusout', handleFocusOut);

      scope.$on('$destroy', () => {
        element.off('focusout', handleFocusOut);
        $timeout.cancel(pendingTimeout);
      });

      function handleFocusOut() {
        $timeout.cancel(pendingTimeout);
        pendingTimeout = $timeout(() => {
          if (dropdownCtrl.isOpen() && !element[0].contains(document.activeElement)) {
            dropdownCtrl.toggle(false);
          }
        });
      }
    },
  };
}

NvCloseDropdownOnBlur.$inject = ['$timeout'];
